import React from "react";
import { formatDate } from "../../../../../../models/Helpers";

type DateCellProps = {
  date: Date;
};

const DateCell = ({ date }: DateCellProps) => {
  return <td className="text-sm">{formatDate(date)}</td>;
};

export default DateCell;
